import { Controller } from "@hotwired/stimulus"
import autocomplete from 'autocompleter';

export default class extends Controller {
  connect() {
    var input = document.getElementById("autoComplete");

    if (input) {
      autocomplete({
        onSelect: function (item, input) {
          input.value = item.name;
          document.getElementById("city_id").value = item.id;
          document.getElementById("city_iso").value = item.name;
          document.getElementById("latitude").value = item.latitude;
          document.getElementById("longitude").value = item.longitude;
          document.getElementById("pickup_city_id").value = item.pickup_city_id;

          var search_params = new URLSearchParams(window.location.search);
          let url = `${window.location.origin}${window.location.pathname}?city_iso=${item.name}&latitude=${item.latitude}&longitude=${item.longitude}&pickup_city_id=${item.pickup_city_id}`;
          if (search_params.get("start_date") && search_params.get("end_date")) {
            url = `${window.location.origin}${window.location.pathname}?city_iso=${item.name}&latitude=${item.latitude}&longitude=${item.longitude}&start_date=${search_params.get("start_date")}&end_date=${search_params.get("end_date")}&pickup_city_id=${item.pickup_city_id}`;
          }
          window.history.replaceState(null, null, url);
        },
        input: input,
        showOnFocus: false,
        minLength: 1,
        emptyMsg: 'Место не найдено',
        render: function (item, currentValue) {
          var li = document.createElement("li");
          li.classList.add("flex", "items-center", "gap-2.5", "px-4", "py-2.5", "text-base", "text-left", "text-ink-800", "cursor-pointer", "hover:bg-slate-50", "border-b", "border-slate-100", "last:border-0", "transition-colors")
          // Static icon markup only — no user data goes through innerHTML here.
          li.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="text-slate-400 flex-none"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></svg>';
          var label = document.createElement("span");
          if (item._formatted && item._formatted.name) {
            // _formatted is highlight markup (<em>) produced by the trusted search index
            label.innerHTML = item._formatted.name;
          } else {
            label.textContent = item.name;
          }
          li.appendChild(label);
          return li;
        },
        renderGroup: function (groupName, currentValue) {
          var div = document.createElement("div");
          div.textContent = groupName;
          return div;
        },
        className: 'absolute z-50 w-full mt-1 rounded-xl bg-white shadow-brand-3 border border-slate-200 overflow-hidden focus:outline-none',
        fetch: function (text, update) {
          fetch(`/search/places?q=${encodeURIComponent(text)}`, {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
          })
            .then((response) => response.json())
            .then((data) => {
              const hits = data.hits || [];
              update(hits);
              if (hits.length > 0) {
                let item = hits[0]
                document.getElementById("city_id").value = item.id;
                document.getElementById("city_iso").value = item.name;
                document.getElementById("latitude").value = item.latitude;
                document.getElementById("longitude").value = item.longitude;

                var search_params = new URLSearchParams(window.location.search);
                let url = `${window.location.origin}${window.location.pathname}?city_iso=${item.name}&latitude=${item.latitude}&longitude=${item.longitude}`;
                if (search_params.get("start_date") && search_params.get("end_date")) {
                  url = `${window.location.origin}${window.location.pathname}?city_iso=${item.name}&latitude=${item.latitude}&longitude=${item.longitude}&start_date=${search_params.get("start_date")}&end_date=${search_params.get("end_date")}`;
                }
                window.history.replaceState(null, null, url);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        },
        debounceWaitMs: 100,
        preventSubmit: true,
        disableAutoSelect: false,
        container: document.createElement("ul"),
      });
    }


  }
}
